/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfeeorganizer2Inputs */

const en_ticketsfeeorganizer2 = /** @type {(inputs: Ticketsfeeorganizer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me`)
};

const de_ticketsfeeorganizer2 = /** @type {(inputs: Ticketsfeeorganizer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich`)
};

/**
* | output |
* | --- |
* | "Me" |
*
* @param {Ticketsfeeorganizer2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeeorganizer2 = /** @type {((inputs?: Ticketsfeeorganizer2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeeorganizer2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeeorganizer2(inputs)
	return de_ticketsfeeorganizer2(inputs)
});
export { ticketsfeeorganizer2 as "ticketsFeeOrganizer" }